var map = {
	"./sports.de.json": [
		9891,
		7716
	],
	"./sports.el-GR.json": [
		1590,
		5468
	],
	"./sports.en-GB.json": [
		6759,
		5592
	],
	"./sports.et.json": [
		9725,
		6694
	],
	"./sports.fr-FR.json": [
		2263,
		2894
	],
	"./sports.it-IT.json": [
		3980,
		7416
	],
	"./sports.json": [
		7082,
		7674
	],
	"./sports.lt.json": [
		5568,
		1126
	],
	"./sports.nl-NL.json": [
		4839,
		9234
	],
	"./sports.pl.json": [
		7071,
		5704
	],
	"./sports.pt.json": [
		2171,
		3537
	],
	"./sports.ru.json": [
		6913,
		2946
	],
	"./sports.zh-SG.json": [
		951,
		3511
	],
	"./sports.zh-TW.json": [
		7305,
		6229
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6991;
module.exports = webpackAsyncContext;